import type { BaseDataItem } from '@wix/thunderbolt-becky-types'
import type { Ref } from '@wix/materializer'
import { createConsumptionDataNode } from './utils/dataNodeUtils'
import type { DataAndTranslationsWithOverridesRefs } from '../../types'
import { removeHash } from '@wix/thunderbolt-catharsis'
import { RESOLVED_TRANSLATIONS_ASPECT } from '../../../constants'
import { getDataItemRefsWithOverrides } from '../../dataConsumption'
import type { DependenciesData } from './types'

type Dependencies = {
	translationDataItemWithOverrides: Array<Ref<any>>
	dataItemWithOverrides: Array<any>
}

export const DocumentData = createConsumptionDataNode<
	DependenciesData,
	Dependencies,
	DataAndTranslationsWithOverridesRefs
>({
	getDependencies: ({
		queryName,
		templateComponent,
		getOverrideDataRefs,
		createRefInTemplateNamespace,
		getOverrideTranslationDataRefs,
		itemSuffix,
	}) => ({
		dataItemWithOverrides: getDataItemRefsWithOverrides({
			templateComponent,
			queryName,
			createRefInTemplateNamespace,
			getOverrideDataRefs,
			itemSuffix,
		}),
		translationDataItemWithOverrides: [
			...getOverrideTranslationDataRefs(templateComponent.id, itemSuffix),
			createRefInTemplateNamespace<BaseDataItem>(
				RESOLVED_TRANSLATIONS_ASPECT,
				`${removeHash(templateComponent[queryName]!)}${itemSuffix}`
			),
		],
	}),
	toViewItem: ({ id, value: { dataItemWithOverrides, translationDataItemWithOverrides } }) => {
		for (const index in dataItemWithOverrides) {
			const translatedDataItem = dataItemWithOverrides[index] // translated in ModelUpdateTransformer
			const dataItemFromTranslationsMap = translationDataItemWithOverrides![index]

			if (!translatedDataItem && !dataItemFromTranslationsMap) {
				continue
			}

			return { ...(translatedDataItem || dataItemFromTranslationsMap), id }
		}
	},
})
